import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'

const OneLiner = Extension.create({
  name: 'oneLiner',
  
  priority: 1000, // High priority to override other extensions
  
  addKeyboardShortcuts() {
    return {
      'Enter': () => true,
      'Shift-Enter': () => true,
    }
  },
  
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('oneLiner'),
        props: {
          handleKeyDown: (view, event) => {
            if (event.key === 'Enter') {
              return true // Prevent default
            }
            return false
          },
          handlePaste: (view, event) => {
            const text = event.clipboardData?.getData('text/plain')
            if (text) {
              const singleLine = text.replace(/[\r\n]+/g, ' ')
              const { state } = view
              const { tr } = state
              tr.insertText(singleLine)
              view.dispatch(tr)
              return true
            }
            return false
          },
        },
      }),
    ]
  },
})

export default OneLiner